import React from 'react'

export default function ValuationStudy() {
  return (
    <div>ValuationStudy</div>
  )
}
